import User from '@/core/user'

export default {
  /**
   * Connects to login enpoint
   *
   * @param {object}   data - request payload
   * @param {function} [cb] - callback function
   */
  login(data, cb) {
    /** Set payload as form-data */
    var credentials = new FormData()
    credentials.append('user', data.username)
    credentials.append('pass', data.password)

    return this.$user.login(credentials)
  },

  /**
   * Init user in application with reponse from endpoint
   *
   * @param {object}   response - endpoint response
   */
  init(response) {
    const authUser = {}

    if (response.sk) {
      /** Store logged in user */
      this.$user.init(response, authUser)
      this.$store.state.isLoggedIn = true

      User.set(authUser)

      /** Display login info and further login to .NET app */
      // TODO: when home route points to a legacy component
      // login to .NET endpoint must be done beforehand, else do this:
      // NOTICE: [deprecated] `this.$user.loginUrl = this.api.$.Login + authUser.token` (concurrent login)

      this.$user.email = authUser.username

      /**
       * If default route has new namespace
       * don't login to .NET just yet
       */
      if (this.$router.matcher.match('/home').params.namespace === 'd') {
        this.api.get(this.api.$.Login + authUser.token).then((r) => {
          // get csrf token and store it
          const token = (r.data.split('__RequestVerificationToken" type="hidden" value="')[1] || '').split('"')[0]
          if (token) {
            global.localStorage.setItem('evedUserCsrf', token)
            this.$store.state.csrf = token
          }
        })
        this.$router.push('/home')
      } else {
        this.api.get(this.api.$.Login + authUser.token).then((r) => {
          /** Role based routing */
          if (typeof authUser.data.role_id !== 'undefined' && authUser.data.role_id === 'ADMIN') {
            this.$router.push('/admin')
          } else {
            this.$router.push('/home')
          }
        })
      }

    /** User not authenticated */
    } else {
      this.$store.state.isLoggedIn = false
    }

    /** Endpoint returned an error */
    if (response.error) {
      this.loginError.message = response.error
    }
  },

  /**
   * Handles enpoint error
   *
   * @param {object} error - endpoint error
   */
  handle(error) {
    console.warn('Error logging user ', error)
  },

  /**
   * Redirects
   *
   */
  auth() {
    const user = User.get()

    /** If not authorized go to login */
    if (user === null || user === undefined) {
      this.$router.push('/login')

    /** If authorized as admin go to admin */
    } else if (typeof user.data !== 'undefined' && typeof user.data.role_id !== 'undefined' && user.data.role_id === 'ADMIN') {
      this.$router.push('/admin')

    /** If authorized go to home by default */
    } else {
      this.$router.push('/home')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/loginService.js